"use client";
import {
  DestructureAEMLayout,
  matchedProducts,
} from "@/helpers/ServerFuncytions";
import { fetchAlgoliaProduct } from "@/helpers/shoppingListHelper";
import PageWrapper from "@/templates/slugSolution/_components/PageWrapper";
import { getComponentBySlug } from "@/templates/slugSolution/slugMap";
import {
  useEffect,
  useMemo,
  useState,
} from "@/utils/hooks/reactUseCustomHooks";
import { useStoreDetails } from "@/utils/hooks/useStoreDetails";
import React from "react";
import Loader from "@/components/Loader";
import useMediaQuery from "@/utils/hooks/useMediaQuery";

const SlugMain: any = ({ data }: any) => {
  const { Items, ItemsOrder } = DestructureAEMLayout(data);
  const [updatedItems, setUpdatedItems] = useState<any>({});

  const { storeID, storeRegion } = useStoreDetails();
  const [loading, setLoading] = useState(false);
  const mediaQuery: number = useMediaQuery() || 0;

  const mergedArray = useMemo(() => {
    return [...(Items?.featuredproducts?.productIds ?? [])];
  }, [Items]);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(
          hash.substring(1).replaceAll("/", "")
        );
        if (element) {
          const elementTop =
            element.getBoundingClientRect().top + window.pageYOffset;
          const offset = mediaQuery >= 768 ? 160 : 220;
          window.scrollTo({
            top: elementTop - offset,
            behavior: "smooth",
          });
        }
      }, 100);
    }
  }, [mediaQuery]);

  useEffect(() => {
    const getProductsData = async () => {
      try {
        setLoading(true);
        const productArray = mergedArray.map((item) => ({ item_id: item }));
        const productData = await fetchAlgoliaProduct(
          productArray,
          storeID,
          storeRegion
        );

        const productComponents = ["featuredproducts"];

        const updated = { ...Items };
        if (storeID) {
          productComponents.forEach((item) => {
            if (updated?.[item]?.productIds) {
              updated[item].products = matchedProducts(
                productData,
                updated[item].productIds,
                storeID
              );
            }
          });
        }

        setLoading(false);
        setUpdatedItems(updated);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching product data:", error);
      }
    };

    void getProductsData();
  }, [storeID, storeRegion, mergedArray, Items]);

  if (loading) {
    return <Loader />;
  }
  return (
    <PageWrapper
      layout={ItemsOrder}
      props={updatedItems}
      componentMap={getComponentBySlug}
    />
  );
};

export default SlugMain;
